<template>
  <div class="improveInfo">
    <Personal-center-head>
      <div>绑定手机号</div>
    </Personal-center-head>
    <el-dialog
      :visible.sync="dialogVisible"
      :show-close='false'
      :close-on-click-modal='false'
      :close-on-press-escape='false'
      width='50%'
      top='25vh'
    >
      <div class="improveInfo-content">
        <el-form
          :model="ruleForm"
          :rules="rules"
          size="small"
          ref="ruleForm"
          class="demo-ruleForm"
          label-position="top"
          label-width="80px"
        >
          <el-form-item
            label="手机号"
            prop="phone"
          >
            <el-input
              style="width:400px"
              type="text"
              v-model="ruleForm.phone"
              autocomplete="off"
              placeholder="请输入手机号"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="验证码"
            prop="code"
          >
            <div class="proving-code">
              <el-input
                style="width:400px"
                type="text"
                v-model="ruleForm.code"
                autocomplete="off"
                placeholder="请输入验证码"
              ></el-input>
              <get-code
                :ruleForm="ruleForm"
                :type="'INFO'"
              />
            </div>
          </el-form-item>
          <el-form-item>
            <div class="btn-bottom">
              <el-button
                type="primary"
                style="background: #484c7f"
                @click="submitForm('ruleForm')"
              >保存</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PersonalCenterHead from "../../components/PersonalCenterHead/index.vue";
import getCode from '../../components/getCode/index.vue'
export default {
  name: 'getPhone',
  components: {
    PersonalCenterHead,
    getCode,
  },
  data () {
    return {
      leaving: false,
      dialogVisible: true,
      ruleForm: {
        //默认校验
        phone: '',
        code: '',
      },
      rules: {
        //默认
        phone: [
          { required: true, message: '请输入手机号', trigger: 'change' }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'change' }
        ],
      },
      Sharing: {
        teamId: '',
        projectId: '',
        userId: ''
      },
    }
  },
  created () {
    //分享
    if (JSON.parse(localStorage.getItem("Sharing"))) {
      this.Sharing = JSON.parse(localStorage.getItem("Sharing"))
    }
    localStorage.setItem("leaving", this.leaving);
  },
  methods: {
    //提交
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.getSubmitApi()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //提交接口
    async getSubmitApi () {
      const { data: data } = await this.$http.post('wechat/bind', {
        phone: this.ruleForm.phone,
        code: this.ruleForm.code,
        open_id: this.$route.query.open_id,
        team_id: this.Sharing.teamId,
        project_id: this.Sharing.projectId,
        invite_id: this.Sharing.userId,
      })
      localStorage.setItem("token", data.data.access_token);
      localStorage.removeItem("leaving");
      this.getMe()
    },
    //返回token 请求获取用户信息 判断用户信息中的json是否存在 如果存在就 直接登录(去首页)  如果不存在就进入完善信息页面 
    async getMe () {
      const { data: data } = await this.$http.post('me')
      if (data.data.json != null && data.data.json != [] && data.data.json != undefined && data.data.json != '') {
        this.$router.push('/home')
      } else {
        if (data.data.userTypeId == 0) {
          this.$router.push('/improveInfo')
          return
        }
        this.$router.push('/home')
      }
    },
  }
}

</script>
<style lang="less" scoped>
.improveInfo {
  .improveInfo-content {
    // min-height: 300px;
    width: 100%;
    // margin-top: 23px;
    padding: 25px 20px;
    // box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    border-radius: 8px;
    background-color: #fff;
    position: relative;
    .proving-code {
      display: flex;
      :nth-child(2) {
        margin-left: 25px;
      }
    }
  }
  /deep/ .el-dialog__header {
    padding: 0;
  }

  // /deep/ .el-dialog {
  //   margin: 0 auto 50px;
  // }
}
</style> 